/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import { Button } from "@xo-union/tk-component-buttons";
import PropTypes from "prop-types";
import { Body1 } from "@xo-union/tk-ui-typography";
import styles from "./styles.css";
import SharedModal from "../shared/modal/index.js";
var TEXTS = {
  quit: 'Quit',
  keepGoing: 'Keep going',
  quitQuiz: 'Quit the quiz?',
  anythingNotSaved: "Anything you've selected won't be saved"
};
export default function CloseConfirmModal(_ref) {
  var isOpen = _ref.isOpen,
    onCloseModal = _ref.onCloseModal,
    onQuitQuiz = _ref.onQuitQuiz;
  return /*#__PURE__*/React.createElement(SharedModal, {
    isOpen: isOpen,
    onClose: onCloseModal,
    containerClassName: styles['tk-modal-content'],
    wrapperClassName: styles['tk-modal-wrapper']
  }, /*#__PURE__*/React.createElement("h3", {
    className: styles['tk-modal-title']
  }, TEXTS.quitQuiz), /*#__PURE__*/React.createElement(Body1, {
    as: "p",
    className: styles['tk-modal-subtitle']
  }, TEXTS.anythingNotSaved), /*#__PURE__*/React.createElement("div", {
    className: styles['tk-modal-action-buttons']
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    size: "lg",
    onClick: onQuitQuiz,
    className: "".concat(styles['tk-modal-quit-button'], " ").concat(styles['tk-modal-button'])
  }, TEXTS.quit), /*#__PURE__*/React.createElement(Button, {
    color: "tertiary",
    size: "md",
    onClick: onCloseModal,
    className: styles['tk-modal-button']
  }, TEXTS.keepGoing)));
}
process.env.NODE_ENV !== "production" ? CloseConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onQuitQuiz: PropTypes.func.isRequired
} : void 0;